import ArrowChevronBold from './ArrowChevronBold';

export default ArrowChevronBold;
